import { Dialog, DialogContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CommonActionButton from '../../components/CommonActionButton';
import Context from '../../provider';
import QRCode from 'react-qr-code';
import React, { useContext } from 'react';

export default function MemberCodeDialog() {
  const { memberCodeDialog, dispatch, me } = useContext(Context);
  const { t } = useTranslation();

  const handleClose = () => {
    dispatch({ type: 'SET_MEMBER_CODE_DIALOG', payload: { open: false } });
  };

  function PaperComponent() {
    return (
      <DialogContent className='member-code-dialog'>
        <h3>{ t('memberQrCode.title') }</h3>
        <p>{ t('memberQrCode.description') }</p>
        <div className='qrcode-container'>
          <QRCode className='qrcode' size={256} value={me?.loyalty_account?.unique_id} />
          <p>{me?.loyalty_account?.unique_id}</p>
        </div>
        <div className='controls'>
          <CommonActionButton text={t('action.close')} onClick={handleClose} />
        </div>
      </DialogContent>
    );
  }

  return (
    <Dialog
      onClose={handleClose}
      open={memberCodeDialog?.open ?? false}
      PaperComponent={PaperComponent}
    />
  );
}